import React from 'react'

const LeekDumplingNutrients = () => {
	return (
		<div>
			<img
				src='/images/products/dumpling/nutrients/leek-dumpling-nutrients.jpg'
				alt='pak-choy-dumpling-nutrients'
				style={{ display: 'block', margin: '0 auto' }}
			/>
		</div>
	)
}

export default LeekDumplingNutrients
